import { Layout } from '@eventbrite/eds-layout';
import React from 'react';
import { PopularCities } from '../../../../types';
import PopularCitiesContainer from '../PopularCitiesContainer';
import { ThingsToDoShelfContainer } from '../ThingsToDoShelfContainer';
import TopDestinations from '../TopDestinations';
import './HomeBottomShelfContainer.scss';

export interface HomeBottomShelfContainerProps {
    ebDomain: string;
    localizedCountryName: string;
    country_popular_cities?: PopularCities;
    enableTopDestinationsHomepage?: Boolean;
    enablePopularCitiesHomepage?: Boolean;
    launchThingsToDoPage?: Boolean;
    enableThingsToDoPhase2?: Boolean;
}

const shouldDisplayPopularCities = (props: HomeBottomShelfContainerProps) => {
    const {
        country_popular_cities,
        enablePopularCitiesHomepage,
        launchThingsToDoPage,
    } = props;

    return (
        enablePopularCitiesHomepage &&
        launchThingsToDoPage &&
        country_popular_cities?.length
    );
};

export const HomeBottomShelfContainer: React.FunctionComponent<
    HomeBottomShelfContainerProps
> = (props) => {
    const {
        country_popular_cities,
        enableTopDestinationsHomepage,
        enableThingsToDoPhase2,
    } = props;

    return (
        <div className="home-bottom-shelf-container eds-bg-color--grey-100 eds-l-pad-top-20">
            <Layout hasHorizontalGutters={true} maxWidth="large">
                {enableTopDestinationsHomepage && (
                    <TopDestinations
                        ebDomain={props.ebDomain}
                        localizedCountryName={props.localizedCountryName}
                    />
                )}
                {shouldDisplayPopularCities(props) && (
                    <PopularCitiesContainer cities={country_popular_cities} />
                )}
                {enableThingsToDoPhase2 && <ThingsToDoShelfContainer />}
            </Layout>
        </div>
    );
};
